import { ChangeDetectionStrategy, Component, Input, OnChanges, OnDestroy, OnInit, signal, SimpleChanges } from "@angular/core";
import { interval, map, startWith, Subscription } from "rxjs";
import { TranslateModule } from "@ngx-translate/core";
import { DurationConfig, DurationPipe } from "../../../../../../../shared/src/lib/pipe/duration.pipe";
import { MomentDatePipe } from "../../../../../../../shared/src/lib/pipe/moment-date.pipe";

@Component({
  selector: "app-market-countdown",
  imports: [TranslateModule, DurationPipe, MomentDatePipe],
  templateUrl: "./market-countdown.component.html",
  styleUrl: "./market-countdown.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarketCountdownComponent implements OnInit, OnDestroy, OnChanges {
  @Input() marketStartTime: string = "";
  @Input() config: DurationConfig | undefined;
  private timerSubscription: Subscription = new Subscription();
  timeMessage = signal<string>("");
  timeValue = signal<any>(null);
  debugInfo: string = "";
  debug: boolean = false;
  isLessThanADay: boolean = false; // Boolean to check if the start time is less than a day

  ngOnChanges(changes: SimpleChanges) {
    if (changes["marketStartTime"]) {
      const startTime = new Date(changes["marketStartTime"]?.currentValue).getTime();
      this._init(startTime);
    }
  }

  ngOnInit(): void {
    const startTime = new Date(this.marketStartTime).getTime();
    this._init(startTime);
  }

  _init(time: any) {
    if (this.timerSubscription) this.timerSubscription.unsubscribe();
    this.timerSubscription = interval(1000)
      .pipe(
        startWith(0),
        map(() => {
          const now = Date.now();
          const diff = time - now;
          this.debugInfo = `Now: ${new Date(now).toISOString()}, Start: ${new Date(time).toISOString()}, Diff: ${diff}`;

          // Update the boolean based on whether the difference is less than 24 hours
          this.isLessThanADay = diff > 0 ? diff < 86400000 : true; // 86400000 milliseconds in a day

          return diff > 0 ? { message: "Starting in", value: diff } : { message: "Elapsed", value: -diff };
        }),
      )
      .subscribe((output) => {
        this.timeMessage.set(output.message);
        this.timeValue.set(output.value);
      });
  }

  ngOnDestroy(): void {
    if (this.timerSubscription) this.timerSubscription.unsubscribe();
  }
}
